// extracted by mini-css-extract-plugin
module.exports = {"container":"_3UHiLJRLPjMgAOgc4gYEd8 categoriesLayout_container"};